export const tomosData = [
  {
    id: 1,
    title: 'TOMO 1 — FUNDAMENTOS DEL TREKKING AMATEUR',
    tagline: 'De caminar “a ver qué pasa” a salir con criterio',
    pages: 50,
    chapters: [
      {
        title: 'Capítulo 1 — Qué significa realmente hacer trekking',
        topics: [
          'Diferencia entre caminata, senderismo, trekking y montañismo',
          'Por qué el trekking no es solo “caminar mucho”',
          'Los errores más comunes del principiante',
          'Cómo pasar de aficionado casual a trekker preparado',
          'Qué habilidades necesitás desarrollar',
        ],
      },
      {
        title: 'Capítulo 2 — Tipos de trekking y niveles de dificultad',
        topics: [
          'Trekking de baja, media y alta dificultad',
          'Salidas de medio día, día completo y varios días',
          'Senderos señalizados vs. terrenos agrestes',
          'Desnivel, distancia y duración: cómo interpretarlos',
          'Cómo elegir una ruta acorde a tu nivel real',
        ],
      },
      {
        title: 'Capítulo 3 — La mentalidad del trekker amateur',
        topics: [
          'No competir: progresar',
          'Cómo evitar subestimar la montaña',
          'Paciencia, constancia y toma de decisiones',
          'Miedo, cansancio y frustración: cómo manejarlos',
          'El error de querer “hacer la más difícil” demasiado pronto',
        ],
      },
      {
        title: 'Capítulo 4 — Los 10 errores que arruinan una salida',
        topics: [
          'Salir sin revisar clima',
          'Llevar calzado incorrecto',
          'No calcular agua ni comida',
          'Empezar demasiado rápido',
          'No conocer el desnivel',
          'No avisar el itinerario',
          'Llevar mochila mal armada',
          'Depender solo del celular',
          'No respetar señales del cuerpo',
          'No tener plan B',
        ],
      },
      {
        title: 'Capítulo 5 — Cómo medir tu nivel actual',
        topics: [
          'Test básico de resistencia',
          'Test de subida',
          'Test de equilibrio y estabilidad',
          'Cómo saber si estás listo para rutas más largas',
          'Escala personal de dificultad',
          'Registro de progreso',
        ],
      },
      {
        title: 'Capítulo 6 — Objetivos realistas para mejorar',
        topics: [
          'Objetivos por distancia',
          'Objetivos por desnivel',
          'Objetivos por técnica',
          'Objetivos por seguridad',
          'Objetivos por autonomía',
          'Cómo armar tu primera progresión de 8 semanas',
        ],
      },
    ],
  },
  {
    id: 2,
    title: 'TOMO 2 — EQUIPO, MOCHILA Y PREPARACIÓN INTELIGENTE',
    tagline: 'Qué llevar, qué evitar y cómo no cargar de más',
    pages: 50,
    chapters: [
      {
        title: 'Capítulo 1 — El equipo esencial para trekking amateur',
        topics: [
          'Qué es indispensable y qué es opcional',
          'Equipo para salidas cortas',
          'Equipo para salidas largas',
          'Equipo para clima variable',
          'Qué comprar primero si tenés presupuesto limitado',
        ],
      },
      {
        title: 'Capítulo 2 — Calzado: la decisión más importante',
        topics: [
          'Zapatillas de trekking vs. botas',
          'Cuándo usar calzado liviano',
          'Cuándo usar calzado con caña',
          'Suela, agarre, impermeabilidad y comodidad',
          'Cómo evitar ampollas',
          'Cómo probar el calzado antes de una salida',
        ],
      },
      {
        title: 'Capítulo 3 — Sistema de ropa por capas',
        topics: [
          'Capa base',
          'Capa térmica',
          'Capa impermeable/cortaviento',
          'Qué evitar: algodón, exceso de abrigo y mala ventilación',
          'Cómo vestirte para frío, calor, viento y lluvia',
          'Cómo regular temperatura durante la marcha',
        ],
      },
      {
        title: 'Capítulo 4 — Cómo armar la mochila correctamente',
        topics: [
          'Distribución del peso',
          'Qué va arriba, abajo y al centro',
          'Peso ideal según duración de la salida',
          'Cómo ajustar correas',
          'Cómo evitar dolor de espalda y hombros',
          'Checklist de mochila para 1 día',
        ],
      },
      {
        title: 'Capítulo 5 — Hidratación y comida en ruta',
        topics: [
          'Cuánta agua llevar según duración y clima',
          'Sales, electrolitos y bebidas isotónicas',
          'Snacks prácticos',
          'Comidas livianas para caminatas largas',
          'Qué comer antes, durante y después',
          'Errores digestivos comunes en trekking',
        ],
      },
      {
        title: 'Capítulo 6 — Kit básico de seguridad',
        topics: [
          'Botiquín mínimo',
          'Linterna frontal',
          'Silbato',
          'Manta térmica',
          'Navaja/multiherramienta',
          'Protector solar y gorra',
          'Power bank',
          'Mapa físico o descargado',
          'Documentación y contactos de emergencia',
        ],
      },
      {
        title: 'Capítulo 7 — Qué NO llevar',
        topics: [
          'Objetos innecesarios que suman peso',
          'Ropa extra mal elegida',
          'Comida excesiva',
          'Gadgets inútiles',
          'Cómo aligerar sin perder seguridad',
        ],
      },
    ],
  },
  {
    id: 3,
    title: 'TOMO 3 — TÉCNICA DE MARCHA, SUBIDAS Y BAJADAS',
    tagline: 'Caminá mejor, cansate menos y cuidá tus articulaciones',
    pages: 50,
    chapters: [
      {
        title: 'Capítulo 1 — Técnica básica de caminata en sendero',
        topics: [
          'Postura corporal',
          'Mirada y anticipación del terreno',
          'Apoyo del pie',
          'Ritmo constante',
          'Respiración durante la marcha',
          'Cómo caminar sin gastar energía de más',
        ],
      },
      {
        title: 'Capítulo 2 — Cómo subir mejor',
        topics: [
          'Paso corto y constante',
          'Uso eficiente de piernas y glúteos',
          'Cómo evitar quemarte al principio',
          'Respiración en subida',
          'Pausas estratégicas',
          'Qué hacer cuando la pendiente se vuelve intensa',
        ],
      },
      {
        title: 'Capítulo 3 — Cómo bajar sin destruir rodillas',
        topics: [
          'Control del centro de gravedad',
          'Pasos cortos en descenso',
          'Uso de bastones',
          'Cómo frenar sin clavar las rodillas',
          'Errores comunes en bajadas largas',
          'Técnicas para terreno suelto',
        ],
      },
      {
        title: 'Capítulo 4 — Uso correcto de bastones',
        topics: [
          'Cuándo conviene usarlos',
          'Altura ideal',
          'Técnica en subida',
          'Técnica en bajada',
          'Técnica en llano',
          'Errores que los vuelven inútiles',
          'Cómo ahorrar energía con bastones',
        ],
      },
      {
        title: 'Capítulo 5 — Terrenos complicados',
        topics: [
          'Piedras',
          'Barro',
          'Arena',
          'Raíces',
          'Cruces de agua',
          'Nieve liviana',
          'Zonas expuestas',
          'Cómo decidir cuándo avanzar y cuándo volver',
        ],
      },
      {
        title: 'Capítulo 6 — Ritmo, pausas y gestión de energía',
        topics: [
          'El error de empezar fuerte',
          'Ritmo conversacional',
          'Pausas cortas vs. pausas largas',
          'Cómo evitar enfriarte al parar',
          'Cómo administrar energía en rutas largas',
          'Señales de fatiga acumulada',
        ],
      },
      {
        title: 'Capítulo 7 — Técnica para trekking en grupo',
        topics: [
          'Cómo caminar con personas de distinto nivel',
          'Ritmo del grupo',
          'Comunicación básica',
          'Qué hacer si alguien se queda atrás',
          'Cómo evitar presión grupal peligrosa',
          'Reglas simples de seguridad grupal',
        ],
      },
    ],
  },
  {
    id: 4,
    title: 'TOMO 4 — ENTRENAMIENTO FÍSICO PARA TREKKING',
    tagline: 'Resistencia, fuerza, movilidad y prevención de lesiones',
    pages: 50,
    chapters: [
      {
        title: 'Capítulo 1 — Qué capacidades físicas necesita un trekker',
        topics: [
          'Resistencia aeróbica',
          'Fuerza de piernas',
          'Core y estabilidad',
          'Equilibrio',
          'Movilidad',
          'Tolerancia al desnivel',
          'Resistencia mental',
        ],
      },
      {
        title: 'Capítulo 2 — Entrenamiento de resistencia',
        topics: [
          'Caminatas progresivas',
          'Caminatas con mochila',
          'Entrenamiento en cuestas',
          'Escaleras',
          'Bicicleta, running suave y cardio complementario',
          'Cómo mejorar sin sobreentrenar',
        ],
      },
      {
        title: 'Capítulo 3 — Fuerza específica para trekking',
        topics: [
          'Sentadillas',
          'Zancadas',
          'Step-ups',
          'Peso muerto rumano',
          'Elevaciones de gemelos',
          'Puentes de glúteos',
          'Core básico',
          'Cómo adaptar ejercicios según edad y nivel',
        ],
      },
      {
        title: 'Capítulo 4 — Rodillas, tobillos y cadera',
        topics: [
          'Por qué suelen doler en trekking',
          'Ejercicios preventivos para rodilla',
          'Fortalecimiento de tobillo',
          'Estabilidad de cadera',
          'Trabajo de glúteo medio',
          'Cómo detectar molestias antes de que sean lesión',
        ],
      },
      {
        title: 'Capítulo 5 — Movilidad y flexibilidad útil',
        topics: [
          'Movilidad de tobillo',
          'Movilidad de cadera',
          'Flexibilidad de isquiosurales',
          'Descarga de gemelos',
          'Movilidad torácica',
          'Rutina corta antes y después de caminar',
        ],
      },
      {
        title: 'Capítulo 6 — Plan de entrenamiento de 8 semanas',
        topics: [
          'Semana 1 y 2: base y adaptación',
          'Semana 3 y 4: más distancia',
          'Semana 5 y 6: desnivel y mochila',
          'Semana 7: simulación de salida real',
          'Semana 8: descarga y trekking objetivo',
          'Cómo ajustar el plan si tenés poco tiempo',
        ],
      },
      {
        title: 'Capítulo 7 — Recuperación',
        topics: [
          'Sueño',
          'Hidratación post salida',
          'Alimentación',
          'Descarga muscular',
          'Cuándo descansar',
          'Cómo volver a entrenar después de una salida exigente',
        ],
      },
    ],
  },
  {
    id: 5,
    title: 'TOMO 5 — PLANIFICACIÓN, ORIENTACIÓN Y SEGURIDAD',
    tagline: 'Salí preparado, tomá mejores decisiones y reducí riesgos',
    pages: 50,
    chapters: [
      {
        title: 'Capítulo 1 — Cómo planificar una salida de trekking',
        topics: [
          'Elegir destino',
          'Investigar distancia y desnivel',
          'Calcular duración real',
          'Revisar accesos',
          'Revisar permisos',
          'Identificar puntos de agua',
          'Definir horario de inicio y regreso',
        ],
      },
      {
        title: 'Capítulo 2 — Lectura del clima',
        topics: [
          'Qué mirar antes de salir',
          'Temperatura, viento, lluvia y tormentas',
          'Cómo cambia el clima en montaña',
          'Señales de mal tiempo',
          'Cuándo cancelar una salida',
          'El error de confiar solo en “está lindo abajo”',
        ],
      },
      {
        title: 'Capítulo 3 — Orientación básica',
        topics: [
          'Cómo leer un mapa',
          'Qué es una curva de nivel',
          'Cómo interpretar desnivel',
          'Uso básico de brújula',
          'GPS y apps de senderismo',
          'Cómo descargar mapas offline',
          'Por qué no depender solo del celular',
        ],
      },
      {
        title: 'Capítulo 4 — Gestión de riesgos',
        topics: [
          'Riesgos físicos',
          'Riesgos climáticos',
          'Riesgos de terreno',
          'Riesgos por mala planificación',
          'Riesgos grupales',
          'Cómo crear un plan de emergencia simple',
        ],
      },
      {
        title: 'Capítulo 5 — Primeros auxilios básicos en trekking',
        topics: [
          'Ampollas',
          'Torceduras',
          'Golpes',
          'Calambres',
          'Insolación',
          'Hipotermia leve',
          'Deshidratación',
          'Cuándo pedir ayuda',
        ],
      },
      {
        title: 'Capítulo 6 — Decidir cuándo volver',
        topics: [
          'Señales de alerta',
          'Cansancio excesivo',
          'Cambio de clima',
          'Pérdida de ruta',
          'Lesiones',
          'Falta de agua',
          'Presión del grupo',
          'Volver también es una decisión inteligente',
        ],
      },
      {
        title: 'Capítulo 7 — Seguridad para salidas en solitario',
        topics: [
          'Cuándo sí y cuándo no conviene',
          'Avisar itinerario',
          'Horarios seguros',
          'Equipo mínimo',
          'Rutas recomendadas para empezar',
          'Cómo reducir riesgos si vas solo',
        ],
      },
    ],
  },
  {
    id: 6,
    title: 'TOMO 6 — PROGRESIÓN AVANZADA PARA AMATEURS',
    tagline: 'De salidas simples a travesías más largas y exigentes',
    pages: 50,
    chapters: [
      {
        title: 'Capítulo 1 — Cómo escalar tu nivel sin lesionarte',
        topics: [
          'Progresión por distancia',
          'Progresión por desnivel',
          'Progresión por peso de mochila',
          'Progresión por duración',
          'Progresión por dificultad técnica',
          'Cómo saber si estás avanzando demasiado rápido',
        ],
      },
      {
        title: 'Capítulo 2 — Trekking de día completo',
        topics: [
          'Preparación específica',
          'Ritmo de salida larga',
          'Alimentación durante varias horas',
          'Control de temperatura',
          'Manejo del cansancio',
          'Checklist para rutas de 6 a 10 horas',
        ],
      },
      {
        title: 'Capítulo 3 — Introducción a travesías de varios días',
        topics: [
          'Qué cambia respecto a una salida de un día',
          'Equipo extra necesario',
          'Carpa, bolsa y aislante',
          'Gestión de comida',
          'Gestión de agua',
          'Higiene básica',
          'Cómo planificar etapas',
        ],
      },
      {
        title: 'Capítulo 4 — Trekking con desnivel fuerte',
        topics: [
          'Cómo entrenarlo',
          'Cómo subir sin agotarte',
          'Cómo bajar con seguridad',
          'Cómo cuidar rodillas',
          'Cómo calcular tiempos reales',
          'Errores comunes en rutas con mucho desnivel',
        ],
      },
      {
        title: 'Capítulo 5 — Trekking en diferentes ambientes',
        topics: [
          'Montaña',
          'Bosque',
          'Sierras',
          'Patagonia',
          'Zonas áridas',
          'Clima frío',
          'Clima caluroso',
          'Cómo adaptar equipo y estrategia',
        ],
      },
      {
        title: 'Capítulo 6 — Autonomía y confianza',
        topics: [
          'Preparar tus propias rutas',
          'Evaluar dificultad sin depender de otros',
          'Armar tu sistema personal de salida',
          'Aprender de cada experiencia',
          'Registro post trekking',
          'Cómo convertirte en un trekker más independiente',
        ],
      },
      {
        title: 'Capítulo 7 — Tu plan de evolución de 6 meses',
        topics: [
          'Mes 1: base física y salidas simples',
          'Mes 2: técnica y equipo',
          'Mes 3: desnivel moderado',
          'Mes 4: salidas largas',
          'Mes 5: rutas más técnicas',
          'Mes 6: objetivo desafiante',
          'Cómo elegir tu “trekking meta”',
        ],
      },
    ],
  },
]
